import { render, staticRenderFns } from "./instrucciones-baja-dudas.vue?vue&type=template&id=52662b7d&"
import script from "./instrucciones-baja-dudas.vue?vue&type=script&lang=js&"
export * from "./instrucciones-baja-dudas.vue?vue&type=script&lang=js&"
import style0 from "./instrucciones-baja-dudas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports